import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

const Map = () => {

  const mapContainerRef = useRef(null)

  useEffect(() => {

    if (!mapContainerRef.current) return

    delete L.Icon.Default.prototype._getIconUrl

    L.Icon.Default.mergeOptions({

      iconRetinaUrl: markerIcon2x,

      iconUrl: markerIcon,

      shadowUrl: markerShadow,

    })

    const map = L.map(mapContainerRef.current).setView(

      [36.56693798686318, 53.05870542141341],13

    )

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {

      attribution: '&copy; OpenStreetMap contributors',

    }).addTo(map)

    L.marker([36.56693798686318, 53.05870542141341]).addTo(map).bindPopup(`
    <a href="https://neshan.org/maps/@36.56693798686318,53.05870542141341,15z" target="_self" rel="noopener noreferrer">
      مشاهده در نقشه نشان
    </a>
  `).openPopup()

    return () => {
      map.remove()
    }
  }, [])

  return (
    <div
    className="h-full rounded-[15px]"
      ref={mapContainerRef}
    />
  )
}

export default Map;
